import {
  UserOrderRateReasonsService,
  type PostUserOrderRateReasonRequestAdmin,
  type PutUserOrderRateReasonRequestAdmin
} from '@/backend/market'
import { OrderRateReasonRepository } from '../../domain/repositories/OrderRateReasonRepository'
import { OrderRateReasonModel } from '../models/OrderRateReasonModel'
import { OrderRateReasonFilterModel } from '../models/OrderRateReasonFilterModel'
import type { OrderRateReasonFilterEntity } from '../../domain/entities/OrderRateReasonFilterEntity'
import { OrderRateReasonMiniModel } from '../models/OrderRateReasonMiniModel'
import type { OrderRateReasonMiniEntity } from '../../domain/entities/OrderRateReasonMiniEntity'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { CreateUpdateOrderRateReasonEntity } from '../../domain/entities/CreateUpdateOrderRateReasonEntity'
import { CreateUpdateOrderRateReasonModel } from '../models/CreateUpdateOrderRateReasonModel'

export class OrderRateReasonRepositoryImpl implements OrderRateReasonRepository {
  async getOrderRateReasons(
    filterData: OrderRateReasonFilterEntity
  ): Promise<PaginateEntity<OrderRateReasonMiniEntity[]> | { error: true }> {
    try {
      const filterModel = new OrderRateReasonFilterModel(filterData)
      const response = await UserOrderRateReasonsService.getUserOrderRateReasonsAdmin(filterModel)
      const orderRateReasonModel = response.items?.map(
        (item: OrderRateReasonMiniEntity) => new OrderRateReasonMiniModel(item)
      )
      const result = new PaginateEntity<OrderRateReasonMiniEntity[]>(response, orderRateReasonModel)

      return result
    } catch {
      return { error: true }
    }
  }
  async getOrderRateReason(id: number): Promise<OrderRateReasonModel | { error: true }> {
    try {
      const response = await UserOrderRateReasonsService.getUserOrderRateReasonAdmin({ id })
      const orderRateReasonModel = new OrderRateReasonModel(response)
      return orderRateReasonModel
    } catch {
      return { error: true }
    }
  }
  async createOrderRateReason(
    reasonData: CreateUpdateOrderRateReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      await UserOrderRateReasonsService.postUserOrderRateReasonAdmin({
        requestBody: new CreateUpdateOrderRateReasonModel(
          reasonData
        ) as PostUserOrderRateReasonRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateOrderRateReason(
    id: number,
    reasonData: CreateUpdateOrderRateReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      await UserOrderRateReasonsService.putUserOrderRateReasonAdmin({
        id,
        requestBody: new CreateUpdateOrderRateReasonModel(
          reasonData
        ) as PutUserOrderRateReasonRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteOrderRateReason(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await UserOrderRateReasonsService.deleteUserOrderRateReasonAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
